import { Reorder, motion, useDragControls } from "framer-motion";
import ItemMenuSquares, { _imsTypes } from "global/wrappers/ItemMenuSquares";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { Icon, Label } from "semantic-ui-react";
import { golfHelpers } from "../helpers/golfHelpers";
import { useGolfers } from "../useHelpers/useGolfers";

const _useIms = false
const useHandle = false

export default function LineupBuilder({
  allowSorting,
  golfer_partners,
  groupCount,
  handleShowInfo,
  handleUpdateArray,
  items,
  propsToShow,
  selectedRoundType,
}) {

  const { get_courseRoundHandicaps } = useGolfers()


  const controls = useDragControls();

  const [currentItems, setCurrentItems] = useState([]);
  const [draggingItem, setDraggingItem] = useState();

  const maxCount = 1000

  const _currentItems = useMemo(() => {
    get_courseRoundHandicaps({ golfers: items, selectedRoundType })
    return items
  }, [items]);

  useEffect(() => {
    setCurrentItems(_currentItems)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_currentItems]);

  const handle_onReorder = (sortedItems) => {
    try {
      if (!_.isEmpty(sortedItems)) {
        golfHelpers.ammendLineupGroups(sortedItems, groupCount)
        setCurrentItems([...sortedItems]);
        handleUpdateArray && handleUpdateArray([...sortedItems])
      }
    } catch (error) {
      console.log('e', error)
    }
  };

  // group items by groupNumber or by chunk size
  const groups = currentItems && _.some(currentItems, "groupNumber")
    ? _.groupBy(currentItems, "groupNumber")
    : _.chunk(currentItems, groupCount || currentItems.length);

  const lbls_props = (item) => {
    const lbls = []
    _.forEach(propsToShow, (prop) => {
      if (item[prop]) {
        lbls.push(<Label circular color="grey" size="tiny" >{item[prop]}</Label>)
      }
    })
    return lbls
  }

  const item_reorder = (item, groupPosition, groupNumber) => {

    const { firstName, lastName, name, key, _notPlaying, position } = item ?? {}
    // const parts = golfer_partners?.[key]
    // const { partners } = parts ?? {}

    // let title = ''

    // if (partners) {
    //   _.forEach(partners, (partner, partKey) => {
    //     const { firstName, lastName, rounds } = partner ?? {}
    //     if (rounds) {
    //       _.forEach(rounds, (round, roundKey) => {
    //         if (roundKey === selectedRoundType) {
    //           const { record } = round ?? {}
    //           title += firstName + ' ' + lastName + ': ' + record.wins + '/' + record.losses + '/' + record.ties + '\n'
    //         }
    //       })
    //     }
    //   })
    // }

    return <Reorder.Item
      as={motion.div}
      className={`group-item group-num-${groupPosition + 1}`}
      drag={allowSorting || useHandle}
      dragControls={useHandle ? controls : undefined} // 👈 toggle 
      dragListener={!useHandle} // 👈 toggle 
      onDragStart={() => setDraggingItem({ groupKey: groupNumber, itemKey: item.key })}
      onDragEnd={() => setDraggingItem(null)}
      value={item}
      onPointerDown={(e) => {
        if (useHandle) {
          e.preventDefault(); // 🔑 stops text highlight
        }
      }}
      // title={title}
      key={item.key}
      dragConstraints={{ left: 0, right: 0 }}
      whileDrag={{
        scale: 1.05,
        boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
      }}
    >
      <div
        className={`lbl-group ${draggingItem?.itemKey === key ? 'lbl-drag' : ''}`}
        size="small"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', columnGap: '.5em' }}>
          <Label size="tiny" className={`lbl-group-type lbl-group-type-${groupNumber % 2 === 0 ? 'even' : 'odd'} ${draggingItem?.itemKey === key ? 'lbl-drag' : ''} ${position >= maxCount ? 'np' : ''}`}><Icon name='hashtag' />{groupNumber + 1}</Label>
          <Label
            size="tiny"
            color="blue"
            style={useHandle ? { cursor: 'grab' } : {}}
            onPointerDownCapture={(e) => { if (useHandle) controls.start(e) }}
          >{item.position + 1}</Label>
          <div>{name || `${firstName} ${lastName}`}</div>
          {propsToShow && <div> {lbls_props(item)}</div>}
        </div>
        <div>
          <Icon name={'info circle'} color={'blue'} onClick={() => { handleShowInfo(item) }} />
        </div>
      </div>
    </Reorder.Item>
  }

  const item_groupItems = (group, groupKey) => (
    _.map(group, (item, idx) => (
      item_reorder(item, idx, _.parseInt(groupKey))
    ))
  )

  let cn = 'sort-list-container lup-' + groupCount
  if (propsToShow) {
    cn += ' pts'
  }

  const fnAlt_golfer = (item) => {
    // console.log('item', item)
    return item.groupNumber + 1
  }

  if (_useIms) {
    return <ItemMenuSquares
      menuItems={currentItems}
      imsType={_imsTypes.sortSelect}
      fn_altContent={fnAlt_golfer}
      cn={cn}
    ></ItemMenuSquares>
  }


  return (
    <Reorder.Group
      axis="y"
      values={currentItems}
      onReorder={handle_onReorder}
      className={cn}
    >
      {_.flatMap(groups, (group, groupKey) =>
        item_groupItems(group, groupKey)
      )}
    </Reorder.Group>
  );
}



// const SortableItem = ({
//   item,
//   groupNumber,
//   groupPosition,
//   draggingItem,
//   setDraggingItem,
//   allowSorting,
//   title,
//   maxCount,
// }) => {

//   const { firstName, lastName, name, key, _notPlaying, position } = item ?? {}

//   const controls = useDragControls();

//   return <Reorder.Item
//     as={motion.div}
//     className={`group-item group-num-${groupPosition + 1}`}
//     // drag={allowSorting || useHandle}
//     dragControls={useHandle ? controls : undefined} // 👈 toggle
//     dragListener={!useHandle} // 👈 toggle
//     onDragStart={() =>
//       setDraggingItem({
//         groupKey: groupNumber,
//         itemKey: item.key
//       })}
//     onDragEnd={() => setDraggingItem(null)}
//     value={item}
//     onPointerDown={(e) => {
//       if (useHandle) {
//         e.preventDefault(); // 🔑 stops text highlight
//       }
//     }}
//     title={title}
//     key={item.key}
//     dragConstraints={{ left: 0, right: 0 }}
//     whileDrag={{
//       scale: 1.05,
//       boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
//     }}
//   >
//     <div className={`lbl-group ${draggingItem?.itemKey === key ? 'lbl-drag' : ''}`} size="small">
//       <Label size="tiny" className={`lbl-group-type lbl-group-type-${groupNumber % 2 === 0 ? 'even' : 'odd'} ${draggingItem?.itemKey === key ? 'lbl-drag' : ''} ${position >= maxCount ? 'np' : ''}`}><Icon name='hashtag' />{groupNumber + 1}</Label>
//       <Label
//         size="tiny"
//         color="blue"
//         style={useHandle ? { cursor: 'grab' } : {}}
//         onPointerDownCapture={(e) => { if (useHandle) controls.start(e) }}
//       >{item.position + 1}</Label>
//       {name || `${firstName} ${lastName}`}
//       {/* {propsToShow && lbls_props(item)} */}
//     </div>
//   </Reorder.Item>
// }